import { X } from 'lucide-react';
import { Badge } from '../../../shared/components/ui/badge';
import { Button } from '../../../shared/components/ui/button';
import { cn } from '../../../shared/components/ui/utils';

export type FilterTag = {
  id: string;
  label: string;
  value: string;
  type: 'category' | 'specialty' | 'expertise' | 'location' | 'distance' | 'providerName';
};

type FilterTagsProps = {
  filters: FilterTag[];
  onRemove: (filterId: string) => void;
  onClearAll?: () => void;
  showClearAll?: boolean;
  showCount?: boolean;
  className?: string;
};

export const FilterTags = ({
  filters,
  onRemove,
  onClearAll,
  showClearAll = false,
  showCount = false,
  className,
}: FilterTagsProps) => {
  if (filters.length === 0) {
    return null;
  }

  const filterCount = filters.length;
  const countText = filterCount === 1 ? '1 filter active' : `${filterCount} filters active`;

  return (
    <div className={cn('space-y-3', className)}>
      {showCount && (
        <p className="text-sm text-gray-600 font-medium">
          {countText}
        </p>
      )}
      
      <div className="flex flex-wrap items-center gap-2">
        {filters.map((filter) => (
          <Badge
            key={filter.id}
            variant="outline"
            className="pl-3 pr-2 py-1.5 text-sm border-gray-300 bg-white hover:bg-gray-50 transition-colors"
          >
            <span className="mr-2">{filter.value}</span>
            <button
              onClick={() => onRemove(filter.id)}
              className="inline-flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors p-0.5"
              aria-label={`Remove ${filter.value} filter`}
              type="button"
            >
              <X className="h-3 w-3 text-gray-500" />
            </button>
          </Badge>
        ))}
        
        {showClearAll && onClearAll && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearAll}
            className="h-8 text-sm text-[#026857] hover:text-[#025247] hover:bg-[#026857]/5"
          >
            Clear All
          </Button>
        )}
      </div>
    </div>
  );
};

